

<script lang="ts">
  import type { UserViewFrameContext } from "../../_shared/_logic/user-types"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import {
    DEFAULT_PERMISSION_SECTIONS,
    type PermissionSectionConfig,
  } from "@kontextwerk/control-web-frame/routes/OrgaView/subviews/User/logic/permissionSections"
  import type { UserViewFrameContext as ViewFrameContext } from "../../_shared/_logic/user-types"
  import FramePermissionsPage from "@kontextwerk/control-web-frame/routes/OrgaView/subviews/User/pages/Permissions/PermissionsPage.svelte"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: ViewFrameContext
    activeTab: string
  }>()
</script>

<FramePermissionsPage {viewFrameContext} {activeTab} />
